<ng-template multiple-template></ng-template>
